module.exports = __webpack_public_path__ + "v4assets/hybrid-screenshot-dark.0226f69270e666396a2e202d0b0ff8ee.png";